import LOGOUT_USER from "./logout";

// eslint-disable-next-line import/prefer-default-export
export { LOGOUT_USER };
